<template>
    <div class="divWrap">
        <el-form ref="form" :model="formData" label-width="80px" :inline="false" label-position="right">
            <div class="divFormWrap">
                <div class="divInlineBlock">
                    <el-form-item label="券类型">
                        <el-select v-model="formData.productId" placeholder="请选择券类型">
                            <el-option value="" label="全部"></el-option>
                            <el-option
                                v-for="item in getComboBoxCouponType"
                                :key="item.code"
                                :label="item.name"
                                :value="item.code"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="过期时间">
                        <el-date-picker
                            v-model="formData.expireTime"
                            type="datetime"
                            placeholder="选择过期时间"
                            value-format="yyyy-MM-dd HH:mm:ss"
                        >
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="结算时间">
                            <el-date-picker
                                v-model="formData.payTime"
                                type="daterange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                value-format="yyyy-MM-dd">
                            >
                            </el-date-picker>
                        </el-form-item>
                </div>
                <div class="divInlineBlock">
                    <el-form-item label="状态">
                        <el-select v-model="formData.status" placeholder="请选择状态">
                            <el-option value="" label="全部"></el-option>
                            <el-option
                                v-for="item in getComboBoxAuditingType"
                                :key="item.code"
                                :label="item.name"
                                :value="item.code"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="券名称">
                        <el-input class="el-input-change" v-model="formData.batchName"></el-input>
                    </el-form-item>
                </div>
                <el-form-item>
                    <el-button type="primary" @click="onSubmit">查询</el-button>
                    <el-button
                        class="downLoadBtn"
                        @click="onDownLoad"
                        :loading ='downLoading'
                        >下载</el-button>
                </el-form-item>
            </div>
        </el-form>
        <el-table
            :data="purchaseCouponInfos.dataList"
            v-loading="purchaseCouponInfosLoading"
            stripe
            style="width: 100%">
            <el-table-column
                prop="fakeOrderId"
                label="购券订单ID"
                width="100px"
            >
                <template slot-scope="scope">
                    <div class="idColumn">
                        <span v-if="scope.row.isActivity ===1">赠品</span>
                        {{scope.row.fakeOrderId}}
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                prop="channelName"
                label="订单类型"
            >
            </el-table-column>
            <el-table-column
                prop="batchId"
                label="券批次"
                width="100px"
            >
            </el-table-column>
            <el-table-column
                prop="batchName"
                label="券名称"
            >
            </el-table-column>
            <el-table-column
                prop="productName"
                label="券类型"
            >
            </el-table-column>
            <el-table-column
                prop="couponAmount"
                label="面额（元）"
                width="100px"
            >
            </el-table-column>
            <el-table-column
                prop="status"
                label="状态"
                width="120px"
            >
                <template slot-scope="scope">
                    <div v-if="scope.row.status===0">
                        <div class="divSqureBlue"></div>
                        <span class="status_txt">待支付</span>
                    </div>
                    <div v-else-if="scope.row.status===1">
                        <div class="divSqureBlue"></div>
                        <span class="status_txt">待审核</span>
                    </div>
                    <div v-else-if="scope.row.status===2">
                        <div class="divSqureRed"></div>
                        <span class="status_txt">审核失败</span>
                        <el-tooltip placement="top" effect="light">
                            <div style="max-width: 500px;" slot="content">审核失败原因
                                <div class="divToolTip">{{scope.row.checkFailReason}}</div>
                            </div>
                            <i class="el-icon-question"></i>
                        </el-tooltip>
                    </div>
                    <div v-else-if="scope.row.status===3">
                        <div class="divSqureRed"></div>
                        <span class="status_txt">已取消</span>
                    </div>
                    <div v-else-if="scope.row.status===4">
                        <div class="divSqureGreen"></div>
                        <span class="status_txt">待结算</span>
                    </div>
                    <div v-else-if="scope.row.status===5">
                        <div class="divSqureGreen"></div>
                        <span class="status_txt">已结算</span>
                    </div>
                    <!-- update by limeng -->
                    <div v-else-if="scope.row.status===6">
                        <div class="divSqureRed"></div>
                        <span class="status_txt">已退单</span>
                    </div>
                    <!-- update by limeng end-->
                </template>
            </el-table-column>
            <el-table-column
                prop="totalNumber"
                label="总量（张)"
            >
            </el-table-column>
            <el-table-column
                prop="availableNumber"
                label="可发数量（张)"
                width="120px"
            >
            </el-table-column>
            <el-table-column
                prop="needPayTimeStr"
                label="结算时间"
                width="200px"
            >
            </el-table-column>
            <el-table-column
                prop="expireTimeStr"
                label="可发券过期时间"
                width="200px"
            >
            </el-table-column>
            <el-table-column
                prop="option"
                label="操作"
                fixed="right"
                width="200px"
            >
                <template slot-scope="scope">
                    <div v-if="scope.row.status===0">
                        <a href="javascript:void(0)" @click="dialogShowDetail(scope.row.realOrderId)">详情</a>&nbsp;
                        <a href="javascript:void(0)" @click="jumpTo(scope.row.realOrderId, 'purchase', 'copy')">复制</a>&nbsp;
                        <a href="javascript:void(0)" @click="jumpTo(scope.row.realOrderId, 'purchase', 'edit')">编辑</a>&nbsp;
                        <a href="javascript:void(0)" @click="jumpTo(scope.row.realOrderId, 'pay')">支付</a>&nbsp;
                        <a href="javascript:void(0)" @click="dialogShowCancel(scope.row.realOrderId)">取消</a>
                    </div>
                    <div v-else-if="scope.row.status===1">
                        <a href="javascript:void(0)" @click="dialogShowDetail(scope.row.realOrderId)">详情</a>&nbsp;
                        <a href="javascript:void(0)" @click="jumpTo(scope.row.realOrderId, 'purchase', 'copy')">复制</a>&nbsp;
                    </div>
                    <div v-else-if="scope.row.status===2">
                        <a href="javascript:void(0)" @click="dialogShowDetail(scope.row.realOrderId)">详情</a>&nbsp;
                        <a href="javascript:void(0)" @click="jumpTo(scope.row.realOrderId, 'purchase', 'copy')">复制</a>&nbsp;
                        <!-- <a href="javascript:void(0)" @click="jumpTo(scope.row.realOrderId, 'purchase', 'edit')">编辑</a>&nbsp; -->
                        <a href="javascript:void(0)" @click="dialogShowCancel(scope.row.realOrderId)">取消</a>
                    </div>
                    <div v-else-if="scope.row.status===3">
                        <a href="javascript:void(0)" @click="dialogShowDetail(scope.row.realOrderId)">详情</a>&nbsp;
                        <a href="javascript:void(0)" @click="jumpTo(scope.row.realOrderId, 'purchase', 'copy')">复制</a>
                    </div>
                    <div v-else-if="scope.row.status===4">
                        <a href="javascript:void(0)" @click="dialogShowDetail(scope.row.realOrderId)">详情</a>&nbsp;
                        <a href="javascript:void(0)" @click="jumpTo(scope.row.realOrderId, 'purchase', 'copy')">复制</a>&nbsp;
                        <a href="javascript:void(0)" @click="checkRefund(scope.row.realOrderId)">退券</a>
                    </div>
                    <div v-else-if="scope.row.status===5">
                        <div v-if="scope.row.isActivity === 0">
                            <a href="javascript:void(0)" @click="dialogShowDetail(scope.row.realOrderId)">详情</a>&nbsp;
                            <a href="javascript:void(0)" @click="jumpTo(scope.row.realOrderId, 'purchase', 'copy')">复制</a>
                        </div>
                        <div v-else>
                            <a href="javascript:void(0)" @click="dialogShowDetail(scope.row.realOrderId)">详情</a>&nbsp;
                        </div>
                    </div>
                   <div v-else-if="scope.row.status===6">
                        <div v-if="scope.row.isActivity === 0">
                            <a href="javascript:void(0)" @click="dialogShowDetail(scope.row.realOrderId)">详情</a>&nbsp;
                            <a href="javascript:void(0)" @click="jumpTo(scope.row.realOrderId, 'purchase', 'copy')">复制</a>&nbsp;
                        </div>
                        <div v-else>
                            <a href="javascript:void(0)" @click="dialogShowDetail(scope.row.realOrderId)">详情</a>&nbsp;
                        </div>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            @size-change="getPurchaseCouponInfosSizeChange"
            @current-change="getPurchaseCouponInfosCurrentChange"
            :current-page="purchaseCouponInfos.pageNum"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="20"
            layout="total, prev, pager, next, sizes"
            :total="purchaseCouponInfos.total"
            class="el-pagenation"
            background
        >
        </el-pagination>
        <div class="divDialog">
            <el-dialog title="购券详情" :visible.sync="dialogVisible" top="0" width="30%">
                <div v-loading="orderInfoLoading">
                    <div class="purchaseInfoTitle">
                        购券信息
                    </div>
                    <div>
                        <div class="divCouponWrap">
                            <CouponCard
                                :validity="orderInfoState.expireTime"
                                :price="orderInfoState.couponAmount" :tip="orderInfoState.couponExplain"
                                :coupontype="orderInfoState.couponType"
                                :couponname="orderInfoState.batchName"
                                :width=335 :height=122
                                padding="15px 12px"
                                nameSize="18px"
                                priceSize="41px"
                                status="1"
                            />
                        </div>
                    </div>
                    <div>
                        <div v-for="(item, index) in orderInfo.purchase" :key="index" class="divPurchaseInfoItem div-purchase-info">
                            <el-row :gutter="20">
                                <el-col :span="7" class="leftCol">
                                    <div>
                                        {{Object.keys(item)[0]}}
                                    </div>
                                </el-col>
                                <el-col :span="17">
                                    <div>
                                        {{item[Object.keys(item)[0]]}}
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                    </div>
                    <div class="purchaseInfoTitle">
                        使用情况
                    </div>
                    <div v-for="(item, index) in orderInfo.use" :key="index" class="divPurchaseInfoItem">
                        <el-row :gutter="20">
                            <el-col :span="7" class="leftCol">
                                <div>
                                    {{Object.keys(item)[0]}}
                                </div>
                            </el-col>
                            <el-col :span="17">
                                <div>
                                    {{item[Object.keys(item)[0]]}}
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                </div>
            </el-dialog>
        </div>
        <el-dialog
            title="确定退券?"
            :visible.sync="dialogRefund"
            width = "700px"
            :close-on-click-modal="false"
            class="refundDia"
        >
            <section class="diaContent">
                <h1>退券后，已发出的出行券不受影响，未发出的全部失效，对应的金额将返还至您的工作台账户；</h1>
                <el-row>
                    <el-col :span="3" class="left">
                        可退金额
                    </el-col>
                    <el-col :span="21" class="price"><strong>{{getOrderRefundInfo ? getOrderRefundInfo.refundAmount: '--'}}<em>元</em></strong></el-col>
                </el-row>
                <el-row>
                    <el-col :span="3" class="left">
                        退款明细
                    </el-col>
                    <el-col :span="21" class="detail">{{refundInfoStr}}</el-col>
                </el-row>
            </section>
            <div slot="footer" class="dialog-footer">
                <el-button  type="primary" @click="refundCoupon" :loading="dialogRefundConfirmBtn">确定退券</el-button>
                <el-button  @click.prevent.stop="dialogRefund = false">取 消</el-button>
            </div>
        </el-dialog>
        <el-dialog
            :visible.sync="dialogRefundFail"
            width = "400px"
            :close-on-click-modal="false"
            class="refundDiaFail"
            :center="true"
        >
            <p>您使用的出行券赠品数量已超过可退数量，无法进行退券</p>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary"  @click.prevent.stop="dialogRefundFail = false">我知道了</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { mapState } from 'vuex'

import CouponCard from '../../components/CouponCard'

import { MessageBox, Message, Loading } from 'element-ui'
export default {
  name: 'purchaseCouponHistory',
  componentName: 'purchaseCouponHistory',
  data () {
    return {
      couponType: '',
      dialogVisible: false,
      cancelOrderId: '',
      formData: {
        groupId: this.$store.state.header.selfGroup.groupId,
        expireTime: '',
        productId: '',
        status: '',
        batchName: '',
        pageNum: 1,
        pageSize: 20
      },
      purchaseCouponRecordsFormData: {
        groupId: this.$store.state.header.selfGroup.groupId,
        orderId: ''
      },
      dialogRefund: false,
      refundOrderid: '',
      dialogRefundConfirmBtn: false,
      dialogRefundFail: false
    }
  },
  methods: {
    onSubmit () {
      this.getCouponHistoryData(1)
    },
    onDownLoad(){
        console.log(this.formData)
        const {groupId,expireTime,productId,status,batchName,payTime=[]} = this.formData
        let payStartTime = payTime && payTime[0] ?  `${payTime[0]} 00:00:00` : ''
        let payEndTime = payTime && payTime[1] ?  `${payTime[1]} 23:59:59` : ''
        this.$store.dispatch('purchaseCouponHistory/downloadHistory', {groupId,expireTime,productId,status,batchName,payStartTime,payEndTime})
    },
    getCouponHistoryData (pageNum) {
      if (pageNum) {
        this.formData.pageNum = pageNum
      }
      let payTime = this.formData.payTime || []
      this.formData.payStartTime = payTime && payTime[0] ?  `${payTime[0]} 00:00:00` : ''
      this.formData.payEndTime = payTime && payTime[1] ?  `${payTime[1]} 23:59:59` : ''
      this.$store.dispatch('purchaseCouponHistory/getPurchaseCouponInfos', this.formData)
    },
    getPurchaseCouponInfosSizeChange (pageSize) {
      this.formData.pageSize = pageSize
      this.getCouponHistoryData()
    },
    getPurchaseCouponInfosCurrentChange (pageNum) {
      this.formData.pageNum = pageNum
      this.getCouponHistoryData()
    },
    dialogShowDetail (realOrderId) {
      this.dialogVisible = true
      this.purchaseCouponRecordsFormData.orderId = realOrderId
      this.$store.dispatch('purchaseCouponHistory/getOrderInfo', this.purchaseCouponRecordsFormData)
      this.omgTrack('es_chuxingquan_xieyi_detail_ck', '出行券模块点击详情')
    },
    dialogShowCancel (realOrderId) {
    //   this.dialogCancelVisible = true
    //   this.cancelOrderId = realOrderId
      let self = this
      MessageBox.confirm('确认取消本次购券吗', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let data = {
          cancel: { orderId: realOrderId },
          formData: { ...self.formData }
        }
        self.$store.dispatch('purchaseCouponHistory/cancelOrder', data)
        self.omgTrack('es_chuxingquan_xieyi_cancel_ck', '出行券模块点击取消')
        self.getCouponHistoryData()
      })
    },
    cancelOrderSubmit () {
      this.$store.dispatch('purchaseCouponHistory/cancelOrder', { orderId: this.cancelOrderId })
      this.dialogCancelVisible = false
      this.omgTrack('es_chuxingquan_xieyi_cancel_ck', '出行券模块点击取消')
    },
    jumpTo (orderId, path, sourcetype) {
      if (sourcetype) {
        if (sourcetype === 'copy') {
          this.omgTrack('es_chuxingquan_xieyi_copy_ck', '出行券模块点击复制')
        } else if (sourcetype === 'edit') {
          this.omgTrack('es_chuxingquan_xieyi_edit_ck', '出行券模块点击编辑')
        }
        this.$router.push({
          path,
          query: {
            orderId,
            sourcetype
          }
        }).catch(err => {})
      } else {
        this.omgTrack('es_chuxingquan_xieyi_pay_ck', '出行券模块点击支付')
        this.$router.push({
          path,
          query: {
            orderId
          }
        }).catch(err => {})
      }
    },
    orderInfoTransData (orderInfo) {
      let data = {
        purchase: [],
        use: []
      }
      if (!orderInfo || Object.keys(orderInfo).length === 0) {
        return data
      }
      let purchaseIndexDict = {
        duration: '发券期限', // 拼接
        city: '可用城市',
        totalNumber: '购券张数',
        totalCouponAmount: '发券总金额',
        payTypeDesc: '结算方式',
        serviceAmount: '制券服务费', // 加文字
        discountAmount: '折扣',
        totalAmount: '总费用', // 拼接
        smsCompanyName: '短信通知时显示的公司名称'
      }
      for (let key in purchaseIndexDict) {
        let tempDict = {}
        let chineseDesc = purchaseIndexDict[key]
        if (key === 'duration') {
          tempDict[chineseDesc] = orderInfo['startTime'] + '-' + orderInfo['expireTime']
        } else if (key === 'totalAmount') {
          tempDict[chineseDesc] = `${orderInfo[key]}元`
        } else if (key === 'totalNumber') {
          tempDict[chineseDesc] = orderInfo['totalNumber'] + '张'
        } else if (key === 'totalCouponAmount' || key === 'serviceAmount') {
          tempDict[chineseDesc] = orderInfo[key] + '元'
        }else if ( key === 'discountAmount' && orderInfo[key] >0){
          tempDict[chineseDesc] = `-${orderInfo[key]}元`
        } else {
          tempDict[chineseDesc] = orderInfo[key]
        }
        //如果是标准短信就不进行展示了
        // console.log('key',key , orderInfo['smsTemplateId'])
        if(key == 'smsCompanyName' && orderInfo['smsTemplateId'] == '-1'){
          data.purchase.push({})
        }else{
          data.purchase.push(tempDict)
        }
        
      }
      let purchaseUseIndexDict = {
        totalNumber: '券总量（张）',
        sendNumber: '已发量（张）',
        useCount: '使用量（张）',
        expireTime: '过期时间'
      }
      for (let key in purchaseUseIndexDict) {
        let tempDict = {}
        let chineseDesc = purchaseUseIndexDict[key]
        if (key === 'totalNumber' || key === 'sendNumber' || key === 'useCount') {
          tempDict[chineseDesc] = orderInfo[key] + '张'
        } else {
          tempDict[chineseDesc] = orderInfo[key]
        }
        data.use.push(tempDict)
      }
      return data
    },
    checkRefund (orderId) {
      Loading.service({fullscreen: true})
      this.refundOrderid = orderId
      //   this.$loading({ fullscreen: true })
      this.$store.dispatch('purchaseCouponHistory/getOrderRefundInfo', {
        orderId
      })
    },
    refundCoupon () {
      this.dialogRefundConfirmBtn = true
      this.$store.dispatch('purchaseCouponHistory/refundOrder', {
        orderId: this.refundOrderid,
        groupId: this.$store.state.header.selfGroup.groupId
      })
    }
  },
  computed: {
    ...mapState({
      purchaseCouponInfos: state => {
        return state.purchaseCouponHistory.purchaseCouponInfos
      },
      getComboBoxCouponType: state => {
        let comboBoxByType = state.purchaseCouponHistory.comboBoxCouponType
        return comboBoxByType
      },
      getComboBoxAuditingType: state => {
        let comboBoxByType = state.purchaseCouponHistory.comboBoxAuditingType
        return comboBoxByType
      },
      purchaseCouponInfosLoading: state => state.purchaseCouponHistory.purchaseCouponInfosLoading,
      orderInfoState: state => {
        let orderInfo = state.purchaseCouponHistory.orderInfo
        return orderInfo
      },
      orderInfoLoading: state => state.purchaseCouponHistory.getOrderInfoLoading,
      getOrderRefundInfo (state) {
        let loadingInstance = Loading.service({fullscreen: true})
        loadingInstance.close()
        let returnVal = false
        if (state.purchaseCouponHistory.getOrderRefundInfo) {
          returnVal = state.purchaseCouponHistory.getOrderRefundInfo.data
        }
        return returnVal
      },
      refundOrderSuccess: state => state.purchaseCouponHistory.refundOrderSuccess,
      downLoading: state => state.purchaseCouponHistory.downLoading,
      creatDownloadTaskSuccess: state => state.purchaseCouponHistory.creatDownloadTaskSuccess,
      creatDownloadTaskFail: state => state.purchaseCouponHistory.creatDownloadTaskFail,
    }),
    orderInfo () {
      let transData = this.orderInfoTransData(this.orderInfoState)
      return transData
    },
    refundInfoStr: function () {
      if (!this.getOrderRefundInfo) {
        return '暂无'
      } else {
        if (this.getOrderRefundInfo.isHaveActivityOrder === 1 && this.getOrderRefundInfo.activityOrderUsedNumber > 0) {
          if(this.getOrderRefundInfo.discount && this.getOrderRefundInfo.discount != 100){
            return `单券面额${this.getOrderRefundInfo.couponAmount}元 X 折扣${this.getOrderRefundInfo.discount}% X (剩余${this.getOrderRefundInfo.orderAvailableNumber}张-赠品使用张数${this.getOrderRefundInfo.activityOrderUsedNumber}张)  = ${this.getOrderRefundInfo.refundAmount}元`
          }else{
            return `单券面额${this.getOrderRefundInfo.couponAmount}元 X (剩余${this.getOrderRefundInfo.orderAvailableNumber}张-赠品使用张数${this.getOrderRefundInfo.activityOrderUsedNumber}张) = ${this.getOrderRefundInfo.refundAmount}元`
          }
        } else {
          if(this.getOrderRefundInfo.discount && this.getOrderRefundInfo.discount != 100){
            return `单券面额${this.getOrderRefundInfo.couponAmount}元  X 折扣${this.getOrderRefundInfo.discount}% X 剩余${this.getOrderRefundInfo.orderAvailableNumber}张 = ${this.getOrderRefundInfo.refundAmount}元`
          }else{
            return `单券面额${this.getOrderRefundInfo.couponAmount}元 X 剩余${this.getOrderRefundInfo.orderAvailableNumber}张 = ${this.getOrderRefundInfo.refundAmount}元`
          }
          
        }
      }
    }
  },
  watch: {
    dialogVisible (val) {
      if (!val) {
        this.$store.dispatch('purchaseCouponHistory/initState', 'orderInfo')
      }
    },
    getOrderRefundInfo (val) {
      if (val) {
        if (val.status === 0) {
          this.dialogRefund = true
        } else {
          this.dialogRefundFail = true
        }
      }
    },
    dialogRefund (val) {
      if (!val) {
        this.dialogRefundConfirmBtn = false
        this.refundOrderid = ''
      }
    },
    refundOrderSuccess (val) {
      this.dialogRefund = false

      if (val) {
        this.$store.commit('purchaseCouponHistory/refundOrder', {res: false})
        if (val.status === 0) {
          Message({
            message: '退单成功',
            type: 'success',
            duration: '1000',
            onClose: function () {
              window.location.reload()
            }
          })
        } else {
          Message.error(val.message)
        }
      }
    },
    creatDownloadTaskSuccess(val){
        if(val){
            this.$message({
                showClose: false,
                message: '新建下载任务成功，请点击任务中心查看',
                type: 'success',
            });
            this.$store.dispatch('purchaseCouponHistory/initState', 'creatDownloadTaskSuccess')
        }    
    },
    creatDownloadTaskFail(){
        if(val){
            this.$message({
                showClose: false,
                message: '新建下载任务失败，请稍后在试',
                type: 'error',
            });
            this.$store.dispatch('purchaseCouponHistory/initState', 'creatDownloadTaskFail')
        }    
    }
  },
  mounted () {
    this.$store.dispatch('purchaseCouponHistory/getComboBoxCouponType', { type: '0' })
    this.$store.dispatch('purchaseCouponHistory/getComboBoxAuditingType', { type: '1' })
    this.$store.dispatch('purchaseCouponHistory/getPurchaseCouponInfos', this.formData)
    this.omgTrack('es_chuxingquan_xieyi_history_sw', '出行券模块进入购券历史')
  },
  components: {
    CouponCard
  }
}
</script>

<style lang="stylus">
    inlineBlock()
        display: inline-block;
    divSquare()
        width: 6px;
        height: 6px;
        background-color: arguments;
    .divWrap {
        padding: 20px;
        .status_txt{
            vertical-align: -2px;
            margin-left: 6px;
        }
        .divFormWrap {
            padding: 0 20px;
            .divInlineBlock {
                inlineBlock();
                width: 50%;
            }
            .el-input-change {
                width: 200px;
            }
        }
        .el-button--primary {
            padding: 12px 20px;
        }
        .divDialog {
            .el-dialog__wrapper {
                overflow: hidden;
                div.el-dialog {
                    position: absolute;
                    right: 0;
                    height: 100%;
                    overflow-y: auto;
                }
            }
        }
        .divSqureGreen {
            inlineBlock();
            divSquare(#4DBF84);
        }
        .divSqureRed {
            inlineBlock();
            divSquare(#FF8252);
        }
        .divSqureBlue {
            inlineBlock();
            divSquare(#3468FF);
        }
        .el-pagenation {
            text-align: right;
            margin-top: 10px;
        }
        .divToolTip {
            margin-top: 5px;
        }
        .purchaseInfoTitle {
            background: #F3F4F5;
            padding: 10px 40px;
            color: #333333;
            font-size: 16px;
        }
        .divCouponWrap {
            width: 335px;
            margin: 0 auto;
            margin-top: 20px;
        }
        .el-dialog .el-dialog__header {
            padding: 20px 40px 20px;
        }
        .el-dialog__title {
            font-weight: 500;
        }
        .el-dialog__body {
            padding: 0;
        }
        .divPurchaseInfoItem {
            margin: 10px;
            .leftCol {
                text-align: right;
                color: #999999;
            }
        }
        .div-purchase-info:last-child div.leftCol div {
            width: 92%;
            margin-left: 8%;
        }
        .cell a {
            color: blue;
            width: initial;
        }
    }
    .btnWrap{
        border-top: 1px solid #efefef;
        padding-left 40px
        .refundBtn{
            line-height 40px
        }
    }
    .el-table__row td:first-child{
        padding:0;
        // vertical-align: top;
        .cell {
            padding-left: 20px;
            height: 100%;
            display: flex;
            align-items: center;
        }
    }
    .idColumn{
        position:relative;
        height: inherit;
        display: flex;
        align-items: center;
        span{
            position: absolute;
            top: 2px;
            left: -38px;
            background-color: #fc6f53;
            transform: rotate(-45deg) scaleX(0.8) scaleY(0.8);
            font-size: 10px;
            color: #fff;
            display: inline-block;
            width: 60px;
            text-align: center;
            line-height: 18px;
            height: 18px;
        }
    }
    .refundDia .el-dialog .el-dialog__header{
        padding 30px 40px;
        font-size: 20px;
        color: #333333;
    }
    .refundDia .el-dialog__headerbtn{
        top:30px
    }
    .refundDia .el-dialog__footer{
        text-align:center;
        padding-top:0;
    }
    .refundDia .el-button+.el-button{
        margin-left:20px;
    }
    .diaContent{
        padding: 0  40px 30px 40px
        h1{
            font-size: 18px;
            color: #666666;
            margin:0 0 40px 0;
            line-height:25px

        }
        p{
            font-size: 14px;
            color: #666666;
            line-height:20px;
            padding-bottom:30px;
        }
        .el-row{
            margin-bottom:13px;
            .price{
                font-size: 14px;
                color: #333333;
                position:relative;
                font-weight:500
                strong{
                    font-size: 28px;
                    color: #FC6F53;
                    font-family: "DIN-Medium";
                    position absolute;
                    top:-15px;
                    em{
                        font-size: 14px;
                        color: #333333;
                        font-style:normal
                        margin-left:5px
                    }
                }
            }
            .detail{
                font-size: 14px;
                color: #999999;
            }
        }
        .left{
            font-size: 14px;
            color: #333333;
            font-weight:500
        }
        .right{

        }

    }
    .refundDiaFail{
        p{
            width:320px;
            margin:0 auto;
            font-size: 20px;
            color: #333333;
            text-align: center;
            padding:6px 0 20px;
            font-size:500;
        }
    }
    .downLoadBtn{
        position: absolute;
        top: 5px;
        right: 3px;
    }
    .el-button.is-loading{
        position: absolute;
    }
</style>
